import { Entity } from '../entity';
import { JobMode, JobTemplateMode } from '../enums';
import { PriorityTiny } from '../job';
import { ActivityEntityName, ServiceTypeTag } from '../shared';
import { JobTemplateJob } from './job.template.job';

export const AdHocUniqueId = '00000000-0000-0000-0000-000000000000';
export const AdhocName = 'None';

export interface JobTemplateSummary {
    _id: string;
    name: string;
    description: string;
    mode: JobMode;
    templateMode: JobTemplateMode;
    templateEntity: ActivityEntityName.Job | ActivityEntityName.Opportunity;
    public: boolean;
    workOrderCount: number;
    codeCount: number;
    priority?: PriorityTiny;
    valid?: boolean;
}

export interface JobTemplateEntity extends Entity {
    description: string;
    mode: JobMode;
    templateMode: JobTemplateMode;
    templateEntity: ActivityEntityName.Job | ActivityEntityName.Opportunity;
    public: boolean;


    /** Scope: Site (default), Asset - determines where this template can be used,
     *  i.e. whether this template can be used to add services (recurring job) to a site or asset. */
    scope?: 'Site' | 'Asset',

    serviceType?: ServiceTypeTag;
    serviceFrequency?: ServiceFrequency;

    /** If scope = site, the display: Add related site assets to generated job. */
    addRelatedAssets?: boolean;

    /** If scope = asset, then display: Restrict to specific asset type(s). */
    restrictAssetTypes?: boolean;

    /** If addRelatedAssets or restrictAssetTypes is checked, the user must specify one or more asset types to include. */
    assetTypes?: Entity[];

    enableAutoGeneration?: boolean;
    allowManualGeneration?: boolean;

    /** Requires confirmation for each cycle. (only editable if auto-generation is enabled) */
    requireConfirmation?: boolean;

    calculateNextServiceDate?: NextServiceDateMethod;

}

export interface JobTemplate extends JobTemplateEntity {
    template?: JobTemplateJob;
}

export interface JobTemplateValidateRequest {
    _id?: string;
    name: string;
}

export enum JobTemplateVisibility {
    All = 'all',
    Public = 'public',
    Private = 'private'
}

export enum NextServiceDateMethod {
    LastJobCompletion = 'Last Job Completion',
    ScheduleBaseline = 'Schedule Baseline'
}

export enum ServiceFrequency {
    /** once a year */
    Annually = 'Annually',
    /** every two years */
    Biennially = 'Biennially',
    /** twice a year */
    BiAnnually = 'Bi-Annually',
    /** every 3 months */
    Quarterly = 'Quarterly',
    Monthly = 'Monthly',
}

export interface JobTemplateRequest {
    entity: ActivityEntityName,
    templateMode?: JobTemplateMode[],
    mode?: JobMode
}